<template>
  <div class="main-container">
    <!-- Author: Siddhartha 
      Date: 17/01/2020
    Issue Description: Dashboard Reports children components-->
    <breadcrumb :list="breadcrumbList" />

    <div class="margintop-32" />
    <tl-header type="h1">Reports</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="componentName" v-for="(nav, index) in navList" :key="index">
        <div class="c-title">{{nav.name}}</div>
        <!-- <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      breadcrumbList: [
        {
          name: "Reports",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Report Central",
          url: ``
        }
      ],
      navList: [
        {
          name: "Report Central",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
      ]
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

</style>
